import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  HeadingStyled,
  RoleStatus,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  NavSidebarWrapper,
  ProfileBannerWrapper,
  ProfileContainer,
  ProfileContent,
  ProfileWrapper,
  PropertiesStatusWrapper,
  SocialWrappper,
  UserProfileContentWrapper,
} from "../styled";
import { tabsArrayList } from "../TabsArray";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import BannerImage from "../components/BannerImage";
import ProfileImageUpload from "../components/ProfileImageUpload";
import {
  ProfileSidebarList,
  SocialProfile,
  specializationDropdownList,
} from "../../../../helpers/webConstants";
import {
  AvatarPlaceholder,
  Facebook,
  FalLogo,
  Globe,
  Instagram,
  Linkedin,
  Mosoq,
  One,
  ProfileImg,
  Website,
  XSocial,
  Youtube,
} from "../../../../components/styled/AllImages";
import { UserProfileLogos } from "../../../../helpers/dummyConstants";
import { Col, Row } from "react-bootstrap";
import ServicesCities from "../../../../components/profile/ServicesCities";
import ProfileContact from "../../../../components/profile/contact/ProfileContact";
import LookingFor from "../../../../components/profile/lookingForBanner/LookingForBanner";
import { SmBanner } from "../../../../components/profile/lookingForBanner/styled";
import PopertiesListing from "../properties/popertiesListing";
import LeadFormMobile from "../../enquire/lead-form/LeadFormMobile";
import CustomTooltip from "../../../../components/common/dropdowns/CustomTooltip";
import ProfileSkeleton from "../../../../components/profile/PorfileSkeleton";
import AuthApi from "../../../../services/api/authApi";
import { toast } from "react-toastify";
import ProfileApi from "../../../../services/api/profileApi";
import VisitorApi from "../../../../services/api/visitorApi";
import VisitorBanner from "../components/visitorComponents/VisitorBanner";
import VisitorPropertiesList from "../components/visitorComponents/VisitorPropertiesList";
import AuthHeader from "../../../../components/auth/AuthHeader/AuthHeader";
import { LayoutWrapper, MainContent } from "../../../../layout/ProfileLayout";
import LookingForListing from "../lookingForListing/LookingForListings";
import VisitorLookingForList from "../components/visitorComponents/VisitorLookingForList";

import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import { isValidProfileUsername } from "../../../../utils/profileUsername";
import {
  isLikelyMobileBrowser,
  tryOpenProfileInApp,
} from "../../../../utils/openProfileInApp";
import { AuthContext } from "../../../../context/authContext";
import { requireAuthNavigate } from "../../../../utils";

const ProfileForVisitor = () => {
  const { t, i18n: {language} } = useTranslation();
  const { username } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const sidebarRef = useRef();
  const [userProfile, setUserProfile] = useState({});
  const [listings, setListings] = useState([]);
  const [lookingForListing, setLookingForListing] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [showAllLookingFor, setShowAllLookingFor] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth < 767);
  const appOpenAttempted = useRef(false);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth < 767);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // WhatsApp / in-app browsers often ignore Universal Links — hand off via custom scheme.
  useEffect(() => {
    if (appOpenAttempted.current) return;
    if (!isValidProfileUsername(username)) return;
    if (!isLikelyMobileBrowser()) return;
    appOpenAttempted.current = true;
    tryOpenProfileInApp(username);
  }, [username]);

  const fetchUserProfile = async (name) => {
    try {
      setIsLoading(true);
      const response = await VisitorApi.getSingleProfile(name);

      if (response.code === 200) {
        setUserProfile(response.data);
        setListings(response?.data?.property_listing);
        setLookingForListing(response?.data?.looking_for_listing);
      }
      if (response.code === 204) {
        setNotFound(true);
      }
      if (response.code === 100) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isValidProfileUsername(username)) {
      setNotFound(true);
      setIsLoading(false);
      return;
    }

    setNotFound(false);
    fetchUserProfile(username);
  }, [username, language]);

  return (
    <>
      <LayoutWrapper className="d-flex center-main">
        <AuthHeader />
        <Box className="flex-1 w-100">
          <Box className={"flex-1 custom-scroll content-main"}>
            <Box className="content-inner">
              <MainContent>
                {isLoading ? (
                  <ProfileSkeleton />
                ) : notFound ? (
                  <Box className="d-flex justify-content-center align-items-center h-50">
                    <SpanStyled color="var(--text2)" size="30px">{t("profile_not_found")}</SpanStyled>
                  </Box>
                ) : (
                  <ProfileWrapper>
                    {isLikelyMobileBrowser() && isValidProfileUsername(username) && (
                      <Box className="mb-3 text-center">
                        <a
                          href={`falhub://profile/${encodeURIComponent(username)}`}
                          className="btn btn-primary"
                          style={{
                            background: "#00848D",
                            border: "none",
                            borderRadius: 12,
                            padding: "10px 18px",
                            color: "#fff",
                            fontWeight: 600,
                            textDecoration: "none",
                            display: "inline-block",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            tryOpenProfileInApp(username);
                          }}
                        >
                          {t("open_in_fal_hub_app") || "Open in Fal Hub app"}
                        </a>
                      </Box>
                    )}
                    <ProfileBannerWrapper>
                      <VisitorBanner
                        username={userProfile?.username}
                        coverImg={userProfile?.cover}
                      />
                      <UserProfileContentWrapper>
                        <Row>
                          <Col md={12} lg={7} className="userProfileDetailView">
                            <Box className="userProfileAvatar">
                              <img
                                src={
                                  userProfile?.profile
                                    ? resolveMediaUrl(userProfile?.profile)
                                    : AvatarPlaceholder
                                }
                                alt="Profile Image"
                                className="rounded-circle"
                              />
                            </Box>
                            <Box className="userProfileDetailAbout">
                              <HeadingStyled size="24px" lh="1" weight={"bold"}>
                                {userProfile?.name}
                              </HeadingStyled>
                              <Box className="peopleMainRoleWrapper mt-3 mb-2">
                                <RoleStatus
                                  status={
                                    userProfile?.fal_information?.specialization
                                      ? t(
                                          specializationDropdownList?.find(
                                            (obj) =>
                                              obj.value ===
                                              parseInt(
                                                userProfile.fal_information
                                                  .specialization
                                              )
                                          )?.label || "N/A"
                                        )
                                      : "N/A"
                                  }
                                />
                              </Box>
                              <Box className="userProfileAbout mb-2">
                                <SpanStyled
                                  size="16px"
                                  color="var(--darkGrey)"
                                  weight={"bold"}
                                >
                                  {userProfile?.personal_information?.about_me}
                                </SpanStyled>
                              </Box>
                              <Box className="userProfileLogos">
                                <CustomTooltip
                                  data={{
                                    title: t("fal_id"),
                                    value:
                                      userProfile?.fal_information?.fal_number,
                                  }}
                                  image={FalLogo}
                                />
                                {userProfile?.fal_information
                                  ?.mothoq_number && (
                                  <CustomTooltip
                                    data={{
                                      title: t("wothoq_id"),
                                      value:
                                        userProfile?.fal_information
                                          ?.mothoq_number,
                                    }}
                                    image={Mosoq}
                                  />
                                )}
                                {/* {UserProfileLogos.map((item, key) => (
                      <span className="userProfileLogo" key={key}>
                        {item.logo}
                      </span>
                    ))} */}
                              </Box>
                            </Box>
                          </Col>
                          <Col md={12} lg={5} className="socialPropStats">
                            <SocialWrappper>
                              {userProfile?.social_media?.website_url && (
                                <Link
                                  to={userProfile?.social_media?.website_url}
                                  target="_blank"
                                  title={t("website")}
                                >
                                  <Globe />
                                </Link>
                              )}
                              {userProfile?.social_media
                                ?.youtube_channel_link && (
                                <Link
                                  to={
                                    userProfile?.social_media
                                      ?.youtube_channel_link
                                  }
                                  target="_blank"
                                  title={t("youtube")}
                                >
                                  <Youtube />
                                </Link>
                              )}
                              {userProfile?.social_media
                                ?.linkedin_profile_link && (
                                <Link
                                  to={
                                    userProfile?.social_media
                                      ?.linkedin_profile_link
                                  }
                                  target="_blank"
                                  title={t("linkedin")}
                                >
                                  <Linkedin />
                                </Link>
                              )}
                              {userProfile?.social_media?.x_profile_link && (
                                <Link
                                  to={userProfile?.social_media?.x_profile_link}
                                  target="_blank"
                                  title={t("x")}
                                >
                                  <XSocial />
                                </Link>
                              )}
                              {userProfile?.social_media
                                ?.instagram_profile_link && (
                                <Link
                                  to={
                                    userProfile?.social_media
                                      ?.instagram_profile_link
                                  }
                                  target="_blank"
                                  title={t("instagram")}
                                >
                                  <Instagram />
                                </Link>
                              )}
                              {userProfile?.social_media
                                ?.facebook_profile_link && (
                                <Link
                                  to={
                                    userProfile?.social_media
                                      ?.facebook_profile_link
                                  }
                                  target="_blank"
                                  title={t("facebook")}
                                >
                                  <Facebook width={20} height={20} />
                                </Link>
                              )}
                              {userProfile?.social_media
                                ?.one_day_profile_link && (
                                <Link
                                  to={
                                    userProfile?.social_media
                                      ?.one_day_profile_link
                                  }
                                  target="_blank"
                                  title={t("one_day")}
                                >
                                  <One width={22} height={22} />
                                </Link>
                              )}
                            </SocialWrappper>
                            <PropertiesStatusWrapper>
                              {userProfile?.personal_information
                                ?.years_of_experience && (
                                <Box className="propertiesStatusContainer">
                                  <Box className="propertiesStatusBox">
                                    <Box className="propertiesStatusExperience">
                                      <SpanStyled
                                        family="var(--bold)"
                                        lh="1"
                                        size="12px"
                                      >
                                        {
                                          userProfile?.personal_information
                                            ?.years_of_experience
                                        }
                                      </SpanStyled>
                                    </Box>
                                  </Box>
                                  <Box className="propertiesStatusTitleNum">
                                    <TextStyled size="14px" lh="1">
                                      {t("YearsofExperience")}
                                    </TextStyled>
                                    <HeadingStyled
                                      color="var(--themeColorSecondary)"
                                      lh=".7"
                                      size="24px"
                                    >
                                      {
                                        userProfile?.personal_information
                                          ?.years_of_experience
                                      }
                                    </HeadingStyled>
                                  </Box>
                                </Box>
                              )}
                              {userProfile?.personal_information
                                ?.properties_sold && (
                                <Box className="propertiesStatusContainer">
                                  <Box className="propertiesStatusBox px-2 text-center">
                                    {t("Sold")}
                                  </Box>
                                  <Box className="propertiesStatusTitleNum">
                                    <TextStyled size="14px" lh="1">
                                      {t("PropertiesSold")}
                                    </TextStyled>
                                    <HeadingStyled
                                      color="var(--themeColorSecondary)"
                                      lh=".7"
                                      size="24px"
                                    >
                                      {
                                        userProfile?.personal_information
                                          ?.properties_sold
                                      }
                                    </HeadingStyled>
                                  </Box>
                                </Box>
                              )}
                            </PropertiesStatusWrapper>
                          </Col>
                        </Row>
                      </UserProfileContentWrapper>
                    </ProfileBannerWrapper>
                    {!showAll && (
                      <ProfileContainer>
                        <Box className="profileContainerWrapper">
                          <ServicesCities
                            cities={
                              userProfile?.personal_information
                                ?.we_operate_in_data
                            }
                          />
                          <ProfileContact
                            details={userProfile?.contact_detail}
                          />
                        </Box>
                        {!isDesktop && (
                          <SmBanner>
                            <Box
                              className="smBannerInner"
                              onClick={() => {
                                const next = `/profile/${userProfile?.username}/inquiry/${userProfile?.id}`;
                                if (
                                  !requireAuthNavigate(
                                    navigate,
                                    isAuthenticated,
                                    next
                                  )
                                ) {
                                  return;
                                }
                                navigate(next);
                              }}
                            >
                              <LookingFor />
                            </Box>
                          </SmBanner>
                        )}
                      </ProfileContainer>
                    )}
                    <Box>
                      <VisitorPropertiesList
                        showAll={showAll}
                        setShowAll={setShowAll}
                        listings={listings}
                        user={userProfile}
                      />
                    </Box>
                    <Box>
                      <VisitorLookingForList
                        showAll={showAllLookingFor}
                        setShowAll={setShowAllLookingFor}
                        listing={lookingForListing}
                        user={userProfile}
                      />
                    </Box>
                    {isDesktop && (
                      <>
                        <SmBanner>
                          <Box
                            className="smBannerInner"
                            style={{ minHeight: "150px" }}
                          >
                            <LookingFor />
                          </Box>
                        </SmBanner>
                        <Box className="px-3" bg="var(--white)">
                          <LeadFormMobile user={userProfile} />
                        </Box>
                      </>
                    )}
                  </ProfileWrapper>
                )}
              </MainContent>
            </Box>
          </Box>
        </Box>
      </LayoutWrapper>
    </>
  );
};

export default ProfileForVisitor;
